document.addEventListener("DOMContentLoaded", () => {
  const sliderEl = document.getElementById("testimonials__slider_2");
  if (!sliderEl) return;

  const arrowWrappers = sliderEl
    .closest(".testimonials-v2")
    ?.querySelectorAll(".testimonialsv2__arrows");

  const slider = new KeenSlider(sliderEl, {
    loop: false,
    slides: {
      perView: 3,
      spacing: 40,
    },
    breakpoints: {
      "(max-width: 768px)": {
        slides: {
          perView: 1,
          spacing: 16,
        },
      },
    },
    created(s) {
      updateArrows(s);
    },
    slideChanged(s) {
      updateArrows(s);
    },
  });

  function updateArrows(s) {
    if (!arrowWrappers) return;

    arrowWrappers.forEach((wrapper) => {
      const prev = wrapper.querySelector("svg:first-child");
      const next = wrapper.querySelector("svg:last-child");

      if (!prev || !next) return;

      prev.classList.toggle("is-disabled", s.track.details.rel === 0);
      next.classList.toggle(
        "is-disabled",
        s.track.details.rel === s.track.details.maxIdx
      );
    });
  }

  if (arrowWrappers) {
    arrowWrappers.forEach((wrapper) => {
      const prev = wrapper.querySelector("svg:first-child");
      const next = wrapper.querySelector("svg:last-child");

      if (prev) prev.addEventListener("click", () => slider.prev());
      if (next) next.addEventListener("click", () => slider.next());
    });
  }
});
